import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Tag} from "../../models/tag";
import Helpers from "../../utils/helpers";

@Injectable()
export class TagControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getServiceTagList(serviceId: string): Observable<Tag[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/allservicetags") as Observable<Tag[]>;
  }

  public getTagList(): Observable<Tag[]> {
    return this.http.get(this.baseUrl + "tag") as Observable<Tag[]>;
  }

  public createTag(tag: Tag): Observable<Tag> {
    Helpers.trimRecursiveObj(tag);
    const body = JSON.stringify(tag);
    return this.http.post(this.baseUrl + "tag", body) as Observable<Tag>;
  }

  public updateTag(tag: Tag) {
    Helpers.trimRecursiveObj(tag);
    const body = JSON.stringify(tag);
    return this.http.put(this.baseUrl + "tag", body, {responseType: "text"});
  }

}
